export default {
    lang: {
        name: 'Decreased rating'
    }
}